module.exports = __webpack_public_path__ + "img/icon-logo.5e09c222.png";